/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { COLORS } from 'colors';

export const Wrapper = styled.div`
  position: relative;
  height: 100vh;
`;
export const BackgroundImageWrapper = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

export const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: ${COLORS.TRANSLUCENT_BLACK};
`;
export const ContentWrapper = styled.div`
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

export const Nav = styled.nav`
  background: linear-gradient(
    174.06deg,
    rgba(255, 255, 255, 0.05) 5.13%,  /* More transparent */
    rgba(255, 255, 255, 0.005) 95.71%
  );
  backdrop-filter: blur(7px);
  -webkit-backdrop-filter: blur(7px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 58px;
  padding: 1rem 1.5rem;
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.15);  /* Thin white bottom border */
  @media (min-width: 767px) {
    height: 86px;
  }

  @media (min-width: 1024px) {
    padding: 1rem 5rem;
  }
`;

export const LogoBox = styled.div`
  width: 74px;
  height: 40.16px;
  @media (min-width: 767px) {
    width: 129px;
    height: 70px;
  }
`;

export const NavButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;

  .start-buttons {
    display: flex;
    gap: 30px;
    justify-content: center;
    align-items: center;
    @media (min-width: 1024px) {
      gap: 40px;
    }
  }
  .ghost {
    color: ${COLORS.WHITE};
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;
    letter-spacing: 2%;
    text-transform: uppercase;
    &:hover {
      color: ${COLORS.ORANGE};
    }
  }
  @media (min-width: 1024px) {
    gap: 40px;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;
export const HamBurger = styled.div`
  cursor: pointer;
  @media (min-width: 767px) {
    display: none;
  }
`;
export const Menu = styled.div`
  background-color: ${COLORS.WHITE};
  position: absolute;
  top: 58px;
  height: calc(100vh - 58px);
  width: 100%;
  @media (min-width: 767px) {
    top: 86px;
    height: 100vh - 86px;
  }
  z-index: 50;
  @media (min-width: 767px) {
    display: none;
  }
`;
export const HeroSection = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  text-align: center;
  flex-direction: column;
  height: 100vh;
`;

export const HeroTitle = styled.h1`
  color: ${COLORS.WHITE};
  position: relative;
  bottom: 39px;
  font-size: 38px;
  font-weight: 600;
  line-height: 105%;
  letter-spacing: 2%;
  br {
    display: none;
  }
  @media (min-width: 640px) {
    br {
      display: block;
    }
  }
  @media (min-width: 768px) {
    font-size: 68px;
    line-height: 115%;
  }
`;

export const HeroText = styled.p`
  position: relative;
  bottom: 28px;
  font-size: 24px;
  line-height: 23px;
  font-weight: 400;
  letter-spacing: 0%;
  br {
    display: none;
  }
  @media (min-width: 768px) {
    font-size: 24px;
    line-height: 30px;
  }
  @media (min-width: 1024px) {
    br {
      display: block;
    }
  }
`;
export const HeroSectionButton = styled.div`
  position: relative;
  padding-bottom: 10px;
  width: 237.5px;
  height: 64.16px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    position: absolute;
    top: 0;
    height: 100%;
    pointer-events: none;
  }
  .left-icon {
    left: -5px;
    top: 30px;
  }

  .right-icon {
    right: -5px;
    top: -30px;
  }
  .request-demo-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    padding: 6px 12px; /* px-3 = 12px, py-[6px] = 6px */
    font-size: 18px;
    line-height: 100%;
    font-weight: 400;
    border-radius: 10px;
    width: 220.04px;
    height: 48px;
    border: 1px solid rgba(255, 255, 255, 0.24); /* #FFFFFF3D */
    background: linear-gradient(180deg, #ff7a3c 0%, #ff662a 100%),
      radial-gradient(
        100% 100% at 50% 0%,
        rgba(255, 255, 255, 0.15) 0%,
        rgba(255, 255, 255, 0) 100%
      );
    box-shadow: 0px 4px 8px -2px rgba(210, 71, 72, 0.22);
    cursor: pointer;
    transition: all 0.3s ease;
  }
  @media (min-width: 767px) {
    height: 70.16px;
    width: 185.48px;
    .request-demo-btn {
      width: 169px;
      height: 54px;
    }
  }
`;
export const NavButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 4rem 1rem;
`;

// Container for START COVERAGE and LOG IN
export const StartButtons = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: column;
`;

// Divider (the "|")
export const Divider = styled.p`
  color: ${COLORS.BLACK};
  font-size: 1.2rem;
  margin: 0;
`;

// Request Demo button styling
export const RequestDemoButton = styled.button`
  color: ${COLORS.WHITE};
  background-color: ${COLORS.ORANGE_BUTTON};
  margin-top: 2rem;
  padding: 0 1.5rem;
  height: 46px;

  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
`;
